import { createApiWithNewBasePath as api } from "@api";

import {
  CandidateFilters,
  ICandidate,
  IDeclineServiceProviderParams,
  IServiceRequestCandidateParams,
} from "../types";

export const getCandidatesByServiceRequestId = async (
  params: IServiceRequestCandidateParams
): Promise<ICandidate[]> => {
  const { serviceRequestId, sortBy = CandidateFilters.recommended } = params;

  const { data } = await api.get<
    undefined,
    { data: { serviceProviders: ICandidate[] } }
  >(`service_requests/${serviceRequestId}/service_providers?sort_by=${sortBy}`);

  try {
    return data?.data?.serviceProviders;
  } catch (error) {
    throw new Error(error);
  }
};

export const declineServiceProviderService = async ({
  conversationId,
  reason,
  otherReason,
}: IDeclineServiceProviderParams) => {
  const response = await api.post(`conversations/${conversationId}/decline`, {
    reason,
    other_reason: otherReason,
  });

  try {
    return response;
  } catch (error) {
    throw new Error(error);
  }
};
